import './search.scss';


/* @ngInject */
export default class SearchController {
    constructor($scope, $q, SearchService, $analytics) {
        this.$scope = $scope;
        this.$q = $q;
        this.SearchService = SearchService;
        this.$analytics = $analytics;
        this.pipelineTableReadyForData = null;
        this.PageNumber = 0;
        this.TotalCount = 0;
        this.SearchValue = '';
        this.SearchCriteria = 1;
        this.loading = false;
        this.hasSubmittedSearch = false;
        this.filters = SearchService.getSearchFilters();
        this.selectedFilter = this.filters[1]; // Active Projects

        this.searchCriterias = [
            'Last Name',
            'Email',
            'Phone',
            'Street Address',
            'HERO ID',
            'Job Number',
        ];

        this.init();
    }

    /*= ========================================
    =            Private Functions            =
    ========================================= */
    init() {
        this.pipelineTableReadyForData = this.$q((resolve) => {
            this.$scope.$on('pipelineTableReady', resolve);
        });
    }

    search() {
        this.loading = true;
        this.SearchService
            .search({
                SearchCriteria: this.SearchCriteria,
                SearchValue: this.SearchValue,
                PageNumber: this.PageNumber,
                DisplayOption: this.selectedFilter.filterId,
            })
            .then((response) => {
                const data = response.data.Data;
                this.loading = false;
                this.TotalCount = data.TotalCount === undefined ? 0 : data.TotalCount;
                this.alertPipelineTable(data.PipelineFundingRequests);
            });
    }

    alertPipelineTable(data) {
        this.pipelineTableReadyForData.then(() => {
            this.$scope.$broadcast('pipelineTableUpdate', {
                pipelineStageId: 'search',
                data,
            });
        });
    }
    /* -----  End of Private Functions  ------*/

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    switchCriteria(i) {
        this.SearchCriteria = i;
    }

    submitSearch() {
        this.$analytics.eventTrack(this.searchCriterias[this.SearchCriteria - 1], { category: 'Search' });

        this.PageNumber = 0;
        this.hasSubmittedSearch = true;
        this.search();
    }

    switchPage(page) {
        this.PageNumber = page - 1;
        this.search();
    }

    filterSelected(filter) {
        this.selectedFilter = filter;
        this.search();
    }
    /* -----  End of Public Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/search/search.controller.js